module.exports = __webpack_public_path__ + "img/2.e45c6896.svg";